module.exports = __webpack_public_path__ + "img/Mom-icons_Inventory.4d36ab60.png";